import { loadingActions } from 'modules/loading';
import { SECTION } from 'constants/global';
import { sectionsActions } from '.';
import SectionsApi from './repository';

export const getSections = (params = null, options = {}) => async (dispatch) => {
  const silent = Boolean(options?.silent);
  if (!silent) dispatch(loadingActions.show());
  const stopLoading = () => {
    if (!silent) dispatch(loadingActions.hide());
  };

  const onSuccess = (sections) => {
    const auxSections = (sections || []).map((section) => {
      const auxDate = section.expirationDate.split('/').reverse().join('-');
      return {
        ...section,
        auxType: SECTION,
        auxOrder: new Date(auxDate).getTime(),
      };
    });
    auxSections.sort((a, b) => a.auxOrder - b.auxOrder);
    if (!params) {
      dispatch(sectionsActions.success(auxSections));
    }
    stopLoading();
    return auxSections;
  };

  return SectionsApi.getSections(params)
    .then((sections) => {
      if (!sections) {
        dispatch(sectionsActions.error('No sections found'));
        stopLoading();
        return false;
      }
      return onSuccess(sections);
    })
    .catch((error) => {
      if (['No se encontro información.', 'El cliente no se encuentra registrado.'].includes(error?.data?.error)) {
        return onSuccess([]);
      }
      dispatch(sectionsActions.error(error?.message || error));
      stopLoading();
      return false;
    });
};

export const getSection = (sectionId) => {
  return SectionsApi.getSection(sectionId);
};

export const getSectionPayments = (id, status = []) => {
  return SectionsApi.getSectionPayments(id, status);
};

export const getSectionReference = (id, referenceId) => {
  return SectionsApi.getReference(id, referenceId);
};

export const getSectionNotePDF = (id, referenceId) => {
  return SectionsApi.getNotePDF(id, referenceId)
    .then((blob) => {
      window.share('note', blob, 'application/pdf');
      return true;
    }).catch((error) => {
      console.error(error);
      return false;
    });
};
